export const DeckLayerGroups = {
  Wind: 'wind',
  Aircraft: 'aircraft',
  AircraftLabels: 'aircraftLabels',
} as const;

export type DeckLayerGroup =
  (typeof DeckLayerGroups)[keyof typeof DeckLayerGroups];

// Items earlier in the list paint *below* items later in the list.
export const DECK_LAYER_DRAW_ORDER: readonly DeckLayerGroup[] = [
  DeckLayerGroups.Wind,
  DeckLayerGroups.Aircraft,
  DeckLayerGroups.AircraftLabels,
];
